import Header from "./Header";
import Footer from "./Footer";

const Layout = ({
  children,
  showFooter = true,
  showHeader = true,
}) => {
  return (
    <>
      {showHeader && <Header />}

      {children}

      {showFooter && <Footer />}
    </>
  );
};

export default Layout;